import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UtilService } from '../shared/services';

@Component({
  selector: 'app-premium-service-card',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './premium-service-card.component.html',
  styleUrls: ['./premium-service-card.component.scss']
})
export class PremiumServiceCardComponent {
  @Input() data;
  @Output() planPurchase = new EventEmitter();
  isMobile = false;
  constructor(
    private util: UtilService
  ) {}

  onPlanBtnClick() {
    this.planPurchase.emit(this.data.planName);
  }
  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }
}
